<div class="section container-fluid pt-4 pb-5">
    <div class="row justify-content-center">
        <div class="col-10">
            <div class="row">
                <div class="col-lg-6 d-flex flex-column">
                    <span class="banner-sub-title" [routerLink]="['/home']">mums & midwives</span>
                    <span class="banner-title mt-4">Welcome to Mums & Midwives!</span>
                    <span class="banner-sub-text mt-3">A place where expected Māmā/Mothers can easily connect and reach out to local Midwives within their Iwi/communities.  At Mums & Midwives you will find that the midwives available are ready to build a partnership and care for yourself and whānāu. The foundation of these relationships will be built on collaboration, which includes trust, honesty, respect and empowering you to make the best decisions for yourself, pēpi/baby and whānāu/family.</span>
                </div>
                <div class="col-lg-6 mt-4 mt-lg-0">
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="card banner-card" [routerLink]="['/search-listing']">
                                <div class="p-3 d-flex flex-column">
                                    <img class="banner-card-image" src="../../../../../assets/Images/mother.svg"
                                        alt="Are you pregnant?">
                                    <span class="banner-card-title mt-3 mb-2">Find a<br>Midwife</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-4 mt-3 mt-sm-0">
                            <div class="card banner-card" data-toggle="modal" data-target="#due-date-modal-1">
                                <div class="p-3 d-flex flex-column">
                                    <img class="banner-card-image" src="../../../../../assets/Images/calender.svg"
                                        alt="Find your due date">
                                    <span class="banner-card-title mt-3 mb-2">Find your<br>due date</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-4 mt-3 mt-sm-0">
                            <div class="card banner-card h-100" data-toggle="modal" data-target="#login-modal">
                                <div class="p-3 d-flex flex-column">
                                    <img class="banner-card-image" src="../../../../../assets/Images/nurse.svg"
                                        alt="Are you a midwife?">
                                    <span class="banner-card-title mt-3 mb-2">Sign-In</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6 d-flex flex-column">
                    <div class="horizontal-line mt-3"></div>
                    <span class="banner-sub-text mt-4">Now bookings made handy! Download our mobile app now.</span>
                    <div class="download-links mt-3">
                        <a  href="https://play.google.com/store/apps/details?id=com.virajjiwane.mm_app"
                            class = "text-decoration-none">
                          <div class="download-button py-2 pl-3 pr-4 mr-sm-2">
                            <i class="fab fa-google-play brand-icon"></i>
                            <div class="d-flex flex-column ml-3">
                              <span class="download-sub-text">GET IT ON</span>
                              <span class="download-title">Google Play</span>
                            </div>
                          </div>
                        </a>
                        <div class="download-button py-2 pl-3 pr-4 mt-2 mt-sm-0">
                            <i class="fab fa-apple brand-icon"></i>
                            <div class="d-flex flex-column ml-3">
                                <span class="download-sub-text">DOWNLOAD ON THE</span>
                                <span class="download-title">App Store</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-due-date-calc></app-due-date-calc>
